import { render, staticRenderFns } from "./OpsSettingsPanel.vue?vue&type=template&id=3561751c&scoped=true"
import script from "./OpsSettingsPanel.vue?vue&type=script&lang=js"
export * from "./OpsSettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./OpsSettingsPanel.vue?vue&type=style&index=0&id=3561751c&prod&lang=scss&scoped=true"
import style1 from "./OpsSettingsPanel.vue?vue&type=style&index=1&id=3561751c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3561751c",
  null
  
)

export default component.exports